/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, Input, Optional } from '@angular/core';
import { AppRouter, TitleManager } from '@gh/common-shared';
import { CONTEXTABLE_COMPONENT, ContextableComponent } from '../../routing/context';
import { AbstractPageHeaderComponent } from './abstract-page-header.component';

@Component({
  selector: 'gh-page-mobile-header',
  template: require('./page-mobile-header.component.html'),
  styles: [require('./page-mobile-header.component.scss')],
})
export class PageMobileHeaderComponent extends AbstractPageHeaderComponent {
  @Input() back: boolean;
  @Input() parentTitle: string;
  @Input() documentTitle: string;

  constructor(router: AppRouter,
              titleManager: TitleManager,
              @Optional() @Inject(CONTEXTABLE_COMPONENT) contextable?: ContextableComponent) {
    super(router, titleManager, contextable);
  }

  protected buildTitle(): Maybe<string> {
    return this.documentTitle;
  }
}
